import React, { useCallback, useEffect, useState } from 'react';
import { Input, Mask } from 'antd-mobile-v5';
import { reportPop, reportPopClick } from '@/utils/report';
import styles from '../index.less';
import { showToast } from '@/utils/utils';

const POP_NAME = 'remarkpop';

const RemarkModal = ({ visible, pageName, remarkName, onClose, onOk }) => {
  const [remarkValue, setRemarkValue] = useState('');

  const handleClose = useCallback(() => {
    if (onClose) onClose();
    reportPopClick({
      page_name: pageName,
      pop_name: POP_NAME,
      button_name: 'remark_close',
    });
  }, [onClose, pageName]);

  const handleSubmit = useCallback(() => {
    if (!remarkValue) {
      showToast('请输入备注', 1);
      return;
    }
    if (!remarkValue.trim()) {
      showToast('输入的备注不能全为空格', 1);
      return;
    }
    if (onOk) onOk(remarkValue);
    reportPopClick({
      page_name: pageName,
      pop_name: POP_NAME,
      button_name: 'remark_save',
    });
  }, [remarkValue, onOk, pageName]);

  useEffect(() => {
    if (visible) {
      reportPop({
        page_name: pageName,
        pop_name: POP_NAME,
      });
    } else {
      setRemarkValue('');
    }
  }, [visible, pageName]);

  return (
    <Mask visible={visible} opacity="thin">
      <div className={styles.remarkModal}>
        <i className={styles.closeIcon} onClick={handleClose} />
        <h4 className={`${styles.title} ${styles.remarkTitle}`}>设置备注</h4>
        <div className={styles.modalWrap}>
          <span className={styles.title}>当前备注：</span>
          <span className={styles.value}>{remarkName ? remarkName : '无'}</span>
        </div>
        <p className={styles.edit}>编辑备注：</p>
        <div className={styles.inputBox}>
          <Input
            placeholder="输入不超过五个字"
            clearable
            maxLength={5}
            value={remarkValue}
            onChange={value => setRemarkValue(value)}
            className={styles.remarkInput}
          />
        </div>
        <button className={styles.submitBtn} onClick={handleSubmit}>
          保存修改
        </button>
      </div>
    </Mask>
  );
};
export default RemarkModal;
